import React from 'react';
import './App.css';
import './WorkExperience.css';
import fc from './assets/fc.png';
import stanford from './assets/stanford.png';
import codepath from './assets/codepath.png';
import gwc from './assets/gwc.png';
function Education() {
    return (
      <div className="wrapper"> 
      <div className="workExperience">
         <h1 className="sectionHeading"> education</h1>

         
         <div className="picDiv">
            <img src={stanford} className="imgHolder" id="wideImage"></img>
         </div>
         <div className="contentDiv">
            <h2> Bachelor's of Science, Computer Science </h2>
            <h3>Expected Graduation: Spring 2023</h3>
         </div>

         <div className="picDiv">
           <img src={fc} className="imgHolder" id="wideImage"></img>
         </div>
         <div className="contentDiv">
            <h2>Associate's of Science, Computer Science</h2>
            <h3>Graduation Date: May 2020</h3>
         </div>

         <div className="picDiv">
            <img src={codepath} className="imgHolder" id="wideImage"></img>
         </div>
         <div className="contentDiv">
            <h2>iOS Development Course</h2>
            <h3>Fall 2020</h3>
         </div>
         <div className="picDiv">
            <img src={gwc} className="imgHolder" id="wideImage"></img>
         </div>
         <div className="contentDiv">
            <h2>iOS Development Course</h2>
            <h3>Summer 2019</h3>
         </div>
       </div>
       
      </div>
      
      );

}

export default Education;